import React from "react";

const InteractionPrompt = ({ isAndroidTV, onInteraction }) => {
  const message = isAndroidTV
    ? "🔊 소리를 활성화하려면 클릭하세요"
    : "🔊 소리를 활성화하려면 클릭하세요";

  const style = {
    position: "fixed",
    top: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    background: "rgba(0, 0, 0, 0.9)",
    color: "white",
    padding: isAndroidTV ? "20px 30px" : "15px 25px",
    borderRadius: "25px",
    fontSize: isAndroidTV ? "24px" : "16px",
    zIndex: 10000,
    textAlign: "center",
    cursor: "pointer",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    animation: isAndroidTV ? "none" : "fadeInOut 6s ease-in-out infinite",
  };

  return (
    <div style={style} onClick={onInteraction} id="interaction-prompt">
      {message}
    </div>
  );
};

export default InteractionPrompt;
